import {nanoid} from 'nanoid';
import {Dimension, Pair, Point} from './abstract-units';
import {Cell} from './cell';

export enum Side {
    FIRST  = 0, // like Positive side (to the right and bottom from the line).
    SECOND = 1  // like Negative side (to the left and top from the line).
}

export function otherSide(side: Side): Side {
    return side === Side.FIRST ? Side.SECOND : Side.FIRST;
}

export type EdgeSideCells = Cell[];
export type EdgeSides = Pair<EdgeSideCells>;

export interface EdgeDisplayInfo {
    movingAxisPos: number;
    axisRange: Point;
}

export type EdgeId = string;

export function getNewEdgeId(): string {
    return nanoid();
}

export interface Edge {
    id: EdgeId;
    axis: Dimension;
    axisRange: Point;
    movingAxis: Dimension;
    movingAxisPos: number;
    sides: EdgeSides;
    isBoundary: boolean;
    display: EdgeDisplayInfo;
}

export enum BoxEdge {
    TOP    = 0,
    RIGHT  = 1,
    BOTTOM = 2,
    LEFT   = 3
}

export type BoxEdges = [Edge, Edge, Edge, Edge];

export const BOX_EDGES_BY_AXIS: {[axis: number]: Pair<BoxEdge>} = {
    [Dimension.X]: [BoxEdge.TOP, BoxEdge.BOTTOM],
    [Dimension.Y]: [BoxEdge.LEFT, BoxEdge.RIGHT]
};

export const AXIS_BY_BOX_EDGE: {[boxEdge: number]: Dimension} = {
    [BoxEdge.TOP]:    Dimension.X,
    [BoxEdge.RIGHT]:  Dimension.Y,
    [BoxEdge.BOTTOM]: Dimension.X,
    [BoxEdge.LEFT]:   Dimension.Y
};

interface BoxEdgesMap {
    [axis: number]: {
        [side: number]: BoxEdge;
    };
}

export const BOX_EDGES_MAP: BoxEdgesMap = {
    [Dimension.X]: {
        [Side.FIRST]:  BoxEdge.TOP,
        [Side.SECOND]: BoxEdge.BOTTOM
    },
    [Dimension.Y]: {
        [Side.FIRST]:  BoxEdge.LEFT,
        [Side.SECOND]: BoxEdge.RIGHT
    }
};

interface BoxSidesMap {
    [boxEdge: number]: Side;
}

export const BOX_SIDES_MAP: BoxSidesMap = {
    [BoxEdge.TOP]:    Side.FIRST,
    [BoxEdge.RIGHT]:  Side.SECOND,
    [BoxEdge.BOTTOM]: Side.SECOND,
    [BoxEdge.LEFT]:   Side.FIRST
};

export const OPPOSITE_BOX_EDGES_MAP: {[boxEdge: number]: BoxEdge} = {
    [BoxEdge.TOP]:    BoxEdge.BOTTOM,
    [BoxEdge.RIGHT]:  BoxEdge.LEFT,
    [BoxEdge.BOTTOM]: BoxEdge.TOP,
    [BoxEdge.LEFT]:   BoxEdge.RIGHT
};
